import React, { ReactNode } from "react";
import { SubmissionError } from "redux-form";
import ReactNodeError from "src/shared/objects/ReactNodeError";

export interface IExceptionFormatterProps {
  exception:
    | Error
    | Error[]
    | ReactNodeError
    | ReactNodeError[]
    | string
    | string[]
    | ReactNode
    | ReactNode[];
}

export function ExceptionFormatter({ exception }: IExceptionFormatterProps) {
  if (exception instanceof ReactNodeError) {
    return <>{exception.reactNode}</>;
  } else if (exception instanceof Error) {
    let message: string = exception.message;
    if (exception instanceof SubmissionError) {
      if (exception.errors._error) {
        message = exception.errors._error;
      }
    }
    return <ExceptionFormatter exception={message} />;
  } else if (Array.isArray(exception)) {
    return (
      <span>
        {(exception as (Error | ReactNodeError | string)[]).map(
          (message, index) => {
            return (
              <span key={index}>
                <ExceptionFormatter exception={message} />
                <br />
              </span>
            );
          },
        )}
      </span>
    );
  } else {
    return <>{exception}</>;
  }
}

/**
 * @deprecated
 */
export default ExceptionFormatter;
